<template>
  <component
    :is="getRenderer(selectedCondition)"
    :col="selectedCondition"
    :item="item"
    :index="index"
    v-bind="resolveFn(selectedCondition, item, index)">
  </component>
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';
import { RENDERERS } from 'vue-cl/components/DataTable';

export default {
  mixins: [ BaseColumnRendererMixin ],

  computed: {
    selectedCondition() {
      const conditions = this.getConditions();
      const filtered = conditions.filter(c => c.condition());
      switch (filtered.length) {
        case 0: return undefined;
        case 1: return filtered[0];
        default:
          throw Error("Multiple conditions evaluated to true");
      }
    }
  },

  methods: {
    getConditions() {
      const col = this.col;

      if (col.conditions === undefined) {
        throw Error("Bad column: missing 'conditions': " + JSON.stringify(col));
      }

      return this.resolveFn(col.conditions, this.item, this.index);
    },

    getRenderer(col) {
      const renderer = RENDERERS[col.type];
      if (renderer) {
        return renderer;
      }
      return RENDERERS.default;
    },
  }
};
</script>
